import { Box, CircularProgress, Typography, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import { Utilities } from '../../utility/utils';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../store/reducers/store';
import { loadDashboard } from '../../store/actions/dashboard';
import centralIconFront from '../../assets/dashboard_central_icon_front.png';
import centralIconBack from '../../assets/dashboard_central_icon_back.png';

const TotalTargetBubble: React.FC = () => {
    const { t, i18n,  } = useTranslation();
    const theme = useTheme();
    const dispatch = useAppDispatch();
    const targets = useAppSelector(state => state.dashboard.portfoliosTargets);

    useEffect(() => {
        if (targets === undefined) {
            dispatch(loadDashboard());
        }
    }, [dispatch, targets]);

    return <>
        <circle cx="0" cy="0" r="139.298" fill={theme.palette.primary.light} />
        <path d={Utilities.f_svg_ellipse_arc([0, 0], [183, 183], [0, 2 * Math.PI *0.9999], 0)} stroke={theme.palette.primary.main} strokeWidth="15" className='fadein-stroke' />
        {targets && <path d={Utilities.f_svg_ellipse_arc([0, 0], [183, 183], [0, 2 * Math.PI * (targets.totalRaised / targets.totalRaisingTarget)], -Math.PI/2)} stroke={theme.palette.primary.dark} strokeWidth="15" strokeLinecap='round' className='fadein-stroke' />}
        <foreignObject x="-139.298" y="-159.298" width="278.6px" height="278.6px">
            <Box width={"100%"} height={"100%"} display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"center"} gap={"24px"} >
                {targets ?
                    <>
                        <Box display={"flex"} justifyContent={"center"} width={"100%"} sx={{ background: `url('${centralIconBack}') center center no-repeat`}}>
                            <img src={centralIconFront} className='flyingObject' alt={t('A11yTotalFundRaisingLogo')} />
                        </Box>

                        <Typography color={theme.palette.primary.dark} fontSize={"16px"} fontWeight={"600"} className="fadein-content">{t('DashboardTotalTargetText')}</Typography>
                        <Typography color={theme.palette.primary.dark} fontSize={"28px"} fontWeight={"700"} className="fadein-content">{`€${targets.totalRaisingTarget?.toLocaleString(i18n.language)}`}</Typography>
                    </>
                    :
                    <CircularProgress />
                }
            </Box>
        </foreignObject>
    </>;
}

export default TotalTargetBubble;